export default __webpack_public_path__ + "static/media/Fighter.6699a05a.png";